"use client";

import { useEffect, useState } from "react";
import { StarIcon } from "@heroicons/react/24/solid";

export default function TestimonialsSection() {
  const [isVisible, setIsVisible] = useState(false);

  const testimonials = [
    {
      content: "Prep Five has been a game-changer for my sales workflow. The platform's AI-powered insights helped me personalize outreach at scale, identify high-intent prospects faster, and ultimately book more qualified meetings. Vidal and the team truly understand the challenges reps face and built something that feels like a real extension of my process.",
      author: "Sam Fiffick",
      role: "Sales Development Representative (SDR)",
      rating: 5
    },
    {
      content: "I used the information gained from Prep5 when I visited a potential new client this week and they were absolutely blown away with the data and information I was able to quote to them. They couldn't have been more impressed with the pre-meeting preparation. A big thumbs up for Prep5!",
      author: "Chris Nash",
      role: "Fractional Sales Leader",
      rating: 5
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), 200);
        }
      },
      { threshold: 0.1 }
    );

    const section = document.getElementById('testimonials-section');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section id="testimonials-section" className="bg-gray-50 dark:bg-slate-900 py-16 lg:py-24">
      <div className="container mx-auto max-w-7xl px-6 lg:px-8">
        <div className={`text-center transition-all duration-800 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            What Sales Professionals Say
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-slate-300">
            Real results from teams building execution fluency with Salesably
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-1 max-w-4xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-white dark:bg-slate-800 p-8 rounded-2xl shadow-lg border border-gray-100 dark:border-slate-700 transition-all duration-700 ease-out delay-300 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <StarIcon key={i} className="h-5 w-5 text-yellow-400" />
                ))}
              </div>
              
              <blockquote className="text-gray-700 dark:text-slate-300 text-lg leading-relaxed">
                "{testimonial.content}"
              </blockquote>
              
              <div className="mt-6 flex items-center">
                <div className="flex-shrink-0">
                  <div className="h-12 w-12 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center text-white font-semibold">
                    {testimonial.author.split(' ').map(n => n[0]).join('')}
                  </div>
                </div>
                <div className="ml-4">
                  <div className="text-base font-semibold text-gray-900 dark:text-white">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-gray-600 dark:text-slate-400">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
